import styled from "styled-components";
import LoadingOverlay from 'react-loading-overlay-ts';

import ReactMarkdown from "react-markdown";
const StyledLoader = styled(LoadingOverlay)`
  .MyLoader_overlay {
    background: rgba(255, 255, 255, 0.7);
  }
    `

// @ts-ignore
export default function Loader({ active, children })  {
    return (<StyledLoader active={active} classNamePrefix='MyLoader_' spinner>
        {children}
    </StyledLoader>
    )
}
